var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSilhouette = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#ECF3F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C17.9312 8 19.5 9.56875 19.5 11.5C19.5 13.4312 17.9312 15 16 15C14.0688 15 12.5 13.4312 12.5 11.5C12.5 9.56875 14.0688 8 16 8ZM20 18C21.6531 18 23 19.3469 23 21V22H9V21C9 19.3469 10.3469 18 12 18C14.6562 18 14.1031 18.5 16 18.5C17.9031 18.5 17.3406 18 20 18ZM16 7C13.5156 7 11.5 9.01562 11.5 11.5C11.5 13.9844 13.5156 16 16 16C18.4844 16 20.5 13.9844 20.5 11.5C20.5 9.01562 18.4844 7 16 7ZM20 17C17.1125 17 17.7812 17.5 16 17.5C14.225 17.5 14.8844 17 12 17C9.79063 17 8 18.7906 8 21V22C8 22.5531 8.44687 23 9 23H23C23.5531 23 24 22.5531 24 22V21C24 18.7906 22.2094 17 20 17Z",
    fill: "#004288"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSilhouette);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/silhouette.d52965c092669f0b0e7c5861653cfe73.svg";